function formatDateFromDash(date) {
  //input time like this: YYYY-MM-DD
  //output time like this: MM/DD/YYYY
  const splitDates = date.split('-');
  return `${splitDates[1]}/${splitDates[2]}/${splitDates[0]}`;
}

export default {
  formatDateFromDash,
};



// WEBPACK FOOTER //
// ./src/helpers/DateUtil/DateUtil.js